import { render } from "./FormTextFieldComponent.vue?vue&type=template&id=dbb96e7c&scoped=true"
import script from "./FormTextFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormTextFieldComponent.vue?vue&type=script&lang=js"

import "./FormTextFieldComponent.vue?vue&type=style&index=0&id=dbb96e7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb96e7c"]])

export default __exports__